import script from "./ExpenseForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpenseForm.vue?vue&type=script&lang=ts&setup=true"

import "./ExpenseForm.vue?vue&type=style&index=0&id=1179981b&lang=scss"

const __exports__ = script;

export default __exports__